import React, { Component } from 'react';
import axios from '~/data/http/axios';
import ActionHistory from './actionHistory';
import ActionDesc from './actionExplainer'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'
import NumberFormatFunctions from '~/Classes/numberFormatFunctions'

@connect((store) => {
    return { user: store.user, siteMaster: store.siteMaster }
})
class Actions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            actions: {},
        }
        this.getHookActions = this.getHookActions.bind(this);
        this.viewActionHistory = this.viewActionHistory.bind(this)
        this.viewDescription = this.viewDescription.bind(this)
    }

    componentDidMount() {
        this.getHookActions()
    }

    getHookActions() {
        axios.get('/application/account/' + this.props.appBinding.id + '/actions').then(response => {
            this.setState({
                actions: response.data,
                loading: false
            })
        })
    }

    viewActionHistory(action) {
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", <ActionHistory action={action} app={this.props.appData} accApp={this.props.appBinding} goTo={this.props.history.push} />, true, "100vw"));
    }

    viewDescription(action) {
        const drawer = <ActionDesc action={action} app={this.props.appData} accApp={this.props.appBinding} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", drawer, true));
    }

    render() {
        if (this.state.loading) return <LoadingIcons iconType="2" />
        return (
            <Paper>
                <Row className="mar-b25">
                    <Column xs={8}>
                        <h4 className="mar-b10 quickFlex"><div style={{ display: 'inline-flex', marginRight: 10 }}><Icons icon="envelope" circle={true} /></div> Campaign and Automation Action History</h4>
                        {this.props.subtitle}
                    </Column>
                    <Column xs={4} className="end-xs">
                        <Button text="Configure" className="button-primary" iconRight={<Icons icon="cog" />} onClick={this.props.setup} />
                    </Column>
                </Row>

                <div className="quickFlex">
                    {this.props.appData.options.hooks.filter(h => !h.automationonly).map((hook, index) => {
                        return <Paper key={index} style={{ flexGrow: 1, marginLeft: index ? '24px' : '', padding: 20 }}>
                            <div style={{ fontWeight: 600 }} className='mar-b5'>{hook.name}</div>
                            <p>Count: {NumberFormatFunctions.formatNumber(this.state.actions[hook.action])}</p>
                            {Boolean(hook.description) && <Button text="description" className="button-sml mar-r10" onClick={() => this.viewDescription(hook)} />}
                            <Button text="History" className="button-sml" onClick={() => this.viewActionHistory(hook.action)} />
                        </Paper>
                    })}
                </div>
            </Paper>
        );
    }
}

export default Actions;